import { EyebrowMD } from '@/atoms/Text'

export const ClosedCaptionsBadge = () => {
  return <EyebrowMD className="w-fit whitespace-nowrap rounded border px-1">CC</EyebrowMD>
}
